<template>
  <div>
    <div class="is-flex is-justify-content-space-between" style="width: 100%">
      <label class="label">Struktur</label>
      <div style="margin-top: -8px">
        <slot name="header-action"></slot>
      </div>
    </div>
    <div class="route-tree-wrapper p-3">
      <Tree
        :value="treeModel"
        :indent="70"
        style="overflow-y: auto"
        :style="{ height: height }"
      >
        <div slot-scope="{ node, path, tree }" class="is-flex pt-1">
          <a
            href="#"
            :style="{ visibility: isVisible(node) }"
            @click.prevent="tree.toggleFold(node, path)"
          >
            <b-icon :icon="setArrow(node)"></b-icon>
          </a>
          <b-icon
            v-if="node.icon"
            :icon="node.icon"
            type="is-grey"
            class="ml-1"
          ></b-icon>
          <div class="ml-2">
            {{ node.name }}
          </div>
          <div style="margin-left: auto">
            <slot
              name="item-action"
              :route="node"
              :tree="tree"
              :path="path"
              :select="select"
            ></slot>
          </div>
        </div>
      </Tree>
    </div>
  </div>
</template>

<script>
/* eslint-disable no-param-reassign */
import { mapGetters } from 'vuex';
import 'he-tree-vue/dist/he-tree-vue.css';
import { Tree, Fold, cloneTreeData } from 'he-tree-vue';

export default {
  name: 'RouteTreeGroup',
  props: {
    groupId: {
      type: Number,
      required: true,
    },
    height: {
      type: String,
      required: false,
      default: 'initial',
    },
  },
  components: {
    Tree: Tree.mixPlugins([Fold]),
  },
  data() {
    return {
      treeModel: [],
      tree: null,
      selectedRoute: null,
      selectedPath: null,
      editing: false,
    };
  },
  computed: {
    ...mapGetters({
      groupRoutes: 'product/group/route/dataByParentId',
    }),
    // Required for detecting a newly created route
    routes() {
      return this.groupRoutes(this.groupId);
    },
    routesById() {
      return this.routes.reduce((acc, route) => {
        acc[route.id] = route;
        return acc;
      }, {});
    },
    // Transform list of routes into tree of routes
    routeTree() {
      return this.listToTree(this.routes);
    },
  },
  watch: {
    groupId() {
      this.treeModel = cloneTreeData(this.routeTree);
    },
    routes(newVal, oldVal) {
      // Watch for updated route
      if (this.editing && newVal.length === oldVal.length) {
        this.updateRoute(this.selectedRoute);
      }
    },
    // fold routeTree here in case of the user is refreshing the page
    routeTree(newVal, oldVal) {
      if (oldVal.length === 0) {
        this.treeModel = cloneTreeData(newVal);
      }
    },
  },
  methods: {
    listToTree(list) {
      let routeTree = [];

      function getChildren(parentId) {
        const rootTree = list
          .filter((route) => route.parent_id === parentId)
          .sort((a, b) => a.pos - b.pos);

        const output = [];

        rootTree.forEach((root) => {
          const routeCopy = { ...root };
          routeCopy.children = getChildren(root.id);
          routeCopy.$folded = true;
          output.push(routeCopy);
        });

        return output;
      }

      list.forEach(() => {
        routeTree = getChildren(null);
      });

      return routeTree;
    },
    select({
      tree, route, path, edit,
    }) {
      this.editing = true;
      this.tree = tree;
      this.selectedRoute = route;
      this.selectedPath = path;

      const { $folded, ...routeData } = route;

      if (edit === 'filter') {
        this.$emit('filterEdited', routeData);
      }

      if (edit === 'visibility') {
        this.$emit('visibilityEdited', routeData);
      }
    },
    isVisible(node) {
      return node.children && node.children.length ? 'visible' : 'hidden';
    },
    setArrow(node) {
      return node.$folded ? 'angle-right' : 'angle-down';
    },
    updateRoute(node) {
      // Need to be assigned manually
      // Object.assign will cause unexpected behavior
      const updated = this.routesById[node.id];
      node.filter = updated.filter;
      node.visible = updated.visible;

      this.editing = false;
    },
  },
  created() {
    this.treeModel = cloneTreeData(this.routeTree);
  },
};
</script>

<style>
.route-tree-wrapper {
  border: 1px solid #dbdbdb;
  border-radius: 4px;
}
.route-tree-wrapper .he-tree .tree-node {
  border-top: none;
  border-right: none;
  border-left: none;
  border-bottom: 1px solid #dbdbdb;
  margin-bottom: 0;
}
</style>
